export enum LoginMethodsEnum {
  'facebook' = 'facebook',
  'google' = 'google',
  'email' = 'email',
}

export type LoginMethodsType = keyof typeof LoginMethodsEnum;

export type baseEventDataType = {
  eventCategory: string;
  [extraData: string]: string | { [extraDataProperty: string]: string };
};

export const baseEventData: { [name: string]: baseEventDataType } = {
  default: {
    eventCategory: 'my account',
  },
  perks: {
    eventCategory: 'my account - JB Perks',
  },
  checkout: {
    eventCategory: 'checkout',
  },
  receipts: {
    eventCategory: 'eReceipts',
  },
  receiptsPerks: {
    eventCategory: 'eReceipts - JB Perks',
  },
};
